
const heroBannerTabClick = (data: any) => { return (data+" button in Hero-banner clicked") }
const newResaleButtonClick = (data: any) => { return (data+" button in Shop page clicked") }
const disconnectWalletbuttonClick:string = "Disconnect Wallet button clicked"
const buyButtonOnUSDCPaymentClick = "Buy button on USDC payment clicked"

export { heroBannerTabClick,newResaleButtonClick,disconnectWalletbuttonClick,buyButtonOnUSDCPaymentClick }